// @flow
import React, { Component } from "react";

import type { AdminPersonPropsType, AdminPersonStatesType } from "../types/UserFormType";
import { convertImgToDataURLviaCanvas } from "../../global/functions/AdminPrint";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

class AdminPerson extends Component<AdminPersonPropsType, AdminPersonStatesType> {
  constructor(props: AdminPersonPropsType) {
    super(props);
    this.state = {
      faces: null
    };
  }

  componentDidMount() {
    let faces = this.state.faces ? [...this.state.faces] : [];
    if (this.props.person.faces) {
      this.props.person.faces.map((face: *): * => {
        convertImgToDataURLviaCanvas(face, function (dataURL: string) {
          faces.push(dataURL);
          this.setState({ faces: faces });
        }.bind(this));
      });
    }
    else {
      this.setState({ faces: faces });
    }
  }

  componentWillReceiveProps(nextProps: AdminPersonPropsType) {
    if (nextProps.person.faces !== this.props.person.faces) {
      let faces = this.state.faces ? [...this.state.faces] : [];
      nextProps.person.faces.map((face: *): * => {
        convertImgToDataURLviaCanvas(face, function (dataURL: string) {
          faces.push(dataURL);
          this.setState({ faces: faces });
        }.bind(this));
      });
    }
  }

  render(): React$Element<*> | null {
    const person = this.props.person;
    const faceNode = this.state.faces && this.state.faces.map((face: *, j: number): * => (
      <img key={person.uid + "-img-" + j} src={face} className="pad-img right-margin-5" />
    ));

    const conferenceFields = this.props.conferenceFields;
    const userFields = person && person.additional_person_fields;
    const extraColumns = conferenceFields.map((field: *): * => (
      <TableCell padding="dense" className="normal">{userFields[field.name]}</TableCell>
    ));

    return (
      <TableRow hover>
        <TableCell padding="dense" className="normal">{person.first_name}</TableCell>
        <TableCell padding="dense" className="normal">{person.last_name}</TableCell>
        <TableCell padding="dense" className="normal">{person.organisation}</TableCell>
        <TableCell padding="dense" className="normal">{person.email}</TableCell>
        <TableCell padding="dense" className="normal">{faceNode}</TableCell>
        {extraColumns}
      </TableRow>
    );
  }
}

export default AdminPerson;


// WEBPACK FOOTER //
// ./src/conference/component/AdminPerson.js